<template>
    <benefit-list v-if="isEmployee"></benefit-list>
    <benefit-box v-else></benefit-box>
</template>

<script>
import BenefitList from '@/components/benefit/List'
import BenefitBox from '@/components/benefit/Box'

export default {
    name: 'benefits',
    components: {
        BenefitList,
        BenefitBox
    },
    computed: {
        isEmployee: function () {
            return window.getApp.isEmployee
        }
    }
}
</script>
